export default {
  UPDATE: 'VOD.TRANSCODING.UPDATE',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/transcoding.js